export default {
  EQUIPMENT_TYPES: '/carrier/equipment_type',
  TIME_ZONE: '/carrier/timezone'
}
